<template>
  <div class="text-center">
    <v-dialog v-model="show" max-width="420">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{confirmationTitle}}</span>
        </v-card-title>
        <v-card-text>
          <div class="text-h6 pa-6">{{bodyText}}</div>

          <!-- <div class="text-h6 pa-6">Are you sure you want to {{confirmationTitle}}?</div> -->
        </v-card-text>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn text  @click.stop="show = false">Cancel</v-btn>
          <v-btn text  color="primary" @click="closeConfirm">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "messageBox",
  props: ["visible", "confirmationTitle","bodyText"],
  components: {},
  data() {
    return {
      dialog: false,
      title: "",
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("closeBox", false);
        }
      },
    },
  },
  methods: {
    closeConfirm() {
      this.$emit("closeBox", true);
    },
  },
};
</script>